import i18n from '@/libs/i18n/index'
import useEntityCrud from '@/composable/useEntityCrud'

import useErrorManager from '@/composable/useErrorManager'

export default function RedirectSettingsList() {
  function convertResource(resource) {
    return {
      ...resource,
      title: resource.title,
      newLink: resource.newLink,
      oldLink: resource.oldLink,
    }
  }

  const MODULE_NAME = 'redirect-settings'
  const ENDPOINT = 'redirect-links'
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const errorManager = useErrorManager()

  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), sortable: true, type: 'truncate-text', width: 100,
    },
    { key: 'oldLink', label: i18n.t('themeSettings.redirectOldLink') },
    { key: 'newLink', label: i18n.t('themeSettings.redirectNewLink') },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    convertResource,
    errorManager,
    tableColumns,
  }
}
